import mapValuesDeep from '../utils/map-values-deep'

export let LABPlayer = null

/**
 * TODO: Move to utils?
 *
 * Module to expose LAB, StudentPlayer and the LAB Wizard.
 * LAB-related utility methods and constants are also provided.
 *
 * Do not selectively wrap LAB APIs here unless they're all wrapped automatically, i.e.:
 *   - no inconsistencies in how LAB methods are invoked (through this wrapper, or directly on LAB)
 *   - everytime LAB adds a new method, we don't have to update this file
 */
export default {
  init(labServices) {
    LABPlayer = labServices.LABPlayer
  }
}

// Activity Types
export const ASSESSMENT = 'assessment'
export const DROPZONE = 'dropzone'
export const FILLINTHEBLANKS = 'fillintheblanks'
export const FLIPCARD = 'flipcard'
export const GAMESHOW = 'gameshow'
export const HANDOUT = 'handout'
export const LABEL_REVEAL = 'label-reveal'
export const MATCHING = 'matching'
export const MEMORY = 'memory'
export const PUSH = 'push'
export const RANKING = 'ranking'
export const SHOUT_IT_OUT = 'shout-it-out'
export const SPEEDUP = 'speedup'
export const TEAMQUIZ = 'teamquiz'
export const TEAMQUIZ_PRO = 'teamquiz-pro'
export const WORKSPACE = 'workspace'

export function parseJson(json) {
  // Other LPP writers are known to doubly-escape the activity and persist json.
  // Try to unescape up to 2 times.
  const MAX_NUM_ESCAPES = 2

  let result = json || {}
  for (let i = 0; i < MAX_NUM_ESCAPES; ++i) {
    if (typeof result === 'string') {
      result = JSON.parse(result)
    } else {
      break
    }
  }
  return result
}

export function remapImageTokens(activityJson, persistJson) {
  const activity = parseJson(activityJson)

  if (!persistJson) {
    return activity
  }

  const persist = parseJson(persistJson)

  return mapValuesDeep(activity, function (value, key) {
    if (key === 'image' && value in persist) {
      return `cs://${persist[value].guid}`
    }
    return value
  })
}
